import { render, staticRenderFns } from "./e-campaign-statistic.vue?vue&type=template&id=13af7591&"
import script from "./e-campaign-statistic.vue?vue&type=script&lang=js&"
export * from "./e-campaign-statistic.vue?vue&type=script&lang=js&"
import style0 from "./e-campaign-statistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports